import(/* webpackMode: "eager" */ "/vercel/path0/src/app/SearchEngine/page.tsx");
